function Footer () {
    return (
        <footer className="bg-gold py-2">ED研究所 ZENITH</footer>
    );
    
}

export default Footer;